module.exports = __webpack_public_path__ + "img/1561929706.9e6e59e4.jpg";